import { SVG_TYPE } from 'Shared/enums';

export const paymentStatus = [
  { value: 'paid', label: 'Opłacone', svgType: SVG_TYPE.CIRCLE_CHECKED },
  { value: 'unpaid', label: 'Nieopłacone', svgType: SVG_TYPE.CIRCLE_X },
  { value: 'waiting_for_payment', label: 'Oczekiwanie na płatność', svgType: SVG_TYPE.SYNC },
  { value: 'deferred_payment', label: 'Płatność odroczona', svgType: SVG_TYPE.SYNC },
  { value: 'stripe_payment', label: 'Opłacone przez Stripe', svgType: SVG_TYPE.STRIPE, hidden: true },
];
